import { nextTick as re, reactive as pe, computed as W, toValue as j, provide as G, shallowRef as Y, watchEffect as ge, shallowReactive as ie, triggerRef as he, watch as A, onActivated as Qe, onDeactivated as qe, onUnmounted as je, effectScope as Ge } from "vue";
import { a as Ye, b as X, d as ye, u as Je, f as Ve, e as Ie, r as se } from "../useRecycleScroller-D_RDrEg2.js";
import { r as Xe, a as ke } from "../keyField-D6okV6nC.js";
import { c as Ze } from "../dynamicScrollerMeasurement-Cq5NQLJa.js";
function et() {
  const n = /* @__PURE__ */ new Map();
  return {
    on(i, l) {
      let a = n.get(i);
      a || (a = /* @__PURE__ */ new Set(), n.set(i, a)), a.add(l);
    },
    off(i, l) {
      const a = n.get(i);
      a && (a.delete(l), a.size || n.delete(i));
    },
    emit(i, l) {
      const a = n.get(i);
      if (a != null && a.size)
        for (const d of [...a])
          d(l);
    },
    clear() {
      n.clear();
    }
  };
}
function tt(n = {}) {
  const i = n.queueFlush ?? ((m) => re(m)), l = n.overflowQueueFlush ?? i, a = Math.max(1, n.maxTasksPerFlush ?? Number.POSITIVE_INFINITY);
  let d = !1;
  const p = /* @__PURE__ */ new Map();
  function w() {
    d || !p.size || (d = !0, i(x));
  }
  function x() {
    if (d = !1, !p.size)
      return;
    const m = [];
    for (const [g, I] of p)
      if (m.push(I), p.delete(g), m.length >= a)
        break;
    const R = m.map((g) => ({
      task: g,
      value: g.read()
    }));
    for (const g of R)
      g.value != null && g.task.write(g.value), g.task.done();
    p.size && (l(x), d = !0);
  }
  function D(m, R) {
    p.set(m, R), w();
  }
  function y(m) {
    p.delete(m);
  }
  return {
    schedule: D,
    cancel: y
  };
}
function nt(n) {
  for (let i = 0; i < n.length; i++)
    n[i];
}
function Fe(n) {
  return n.item;
}
function Q(n, i) {
  const l = i.get(n);
  return l || n;
}
function it(n) {
  const i = {};
  return Object.defineProperties(i, {
    item: {
      enumerable: !0,
      get: () => n.item.item
    },
    itemWithSize: {
      enumerable: !0,
      get: () => n.item
    },
    size: {
      enumerable: !0,
      get: () => n.item.size
    },
    position: {
      enumerable: !0,
      get: () => n.position
    },
    offset: {
      enumerable: !0,
      get: () => n.offset
    },
    id: {
      enumerable: !0,
      get: () => n.nr.id
    },
    index: {
      enumerable: !0,
      get: () => n.nr.index
    },
    used: {
      enumerable: !0,
      get: () => n.nr.used
    },
    key: {
      enumerable: !0,
      get: () => n.nr.key
    },
    type: {
      enumerable: !0,
      get: () => n.nr.type
    }
  }), i;
}
function rt(n) {
  return n._vs_styleStamp ?? 0;
}
function st(n) {
  return n._vs_visibilityStamp ?? 0;
}
const Te = [
  "position",
  "top",
  "left",
  "transform",
  "willChange",
  "visibility",
  "pointerEvents",
  "display"
];
function Se(n) {
  const i = {};
  for (const l of Te)
    i[l] = n.style[l];
  return i;
}
function _e(n, i) {
  for (const l of Te)
    n.style[l] = i[l] ?? "";
}
function U(n, i, l) {
  n.style[i] !== l && (n.style[i] = l);
}
function ze(n, i, l, a, d, p, w) {
  if (!("view" in i)) {
    _e(n, p);
    return;
  }
  const x = n.tagName === "TR", D = d ? se({
    direction: l,
    flowMode: !0
  }) : se({
    direction: l,
    disableTransform: a || x
  }), y = Ie(Q(i.view, w), {
    direction: l,
    mode: D
  });
  U(n, "position", String(y.position ?? "")), U(n, "top", String(y.top ?? "")), U(n, "left", String(y.left ?? "")), U(n, "transform", D === "flow" || x ? "" : String(y.transform ?? "")), U(n, "willChange", String(y.willChange ?? "")), U(n, "visibility", String(y.visibility ?? "")), U(n, "pointerEvents", String(y.pointerEvents ?? "")), U(n, "display", String(y.display ?? ""));
}
function be(n, i) {
  return "view" in n && !i;
}
function we(n, i, l, a, d, p) {
  if ("view" in n) {
    const w = Q(n.view, p);
    return {
      active: w.nr.used && d,
      id: Fe(w).id
    };
  }
  return {
    active: i.active && d,
    id: ut(
      i.item,
      l,
      a,
      i.index
    )
  };
}
function lt(n, i, l, a) {
  if (!("view" in n))
    return {
      direction: i,
      flowMode: l,
      legacy: !0
    };
  if (l) {
    const p = Q(n.view, a);
    return {
      direction: i,
      flowMode: l,
      legacy: !1,
      visibilityStamp: st(p)
    };
  }
  const d = Q(n.view, a);
  return {
    active: d.nr.used,
    direction: i,
    flowMode: l,
    legacy: !1,
    styleStamp: rt(d),
    position: be(n, l) ? d.position : null,
    offset: be(n, l) ? d.offset : null
  };
}
function Re(n, i) {
  if ("view" in n) {
    const l = Q(n.view, i);
    return {
      item: Fe(l).item,
      active: l.nr.used,
      index: l.nr.index,
      watchData: n.watchData ?? !1,
      emitResize: n.emitResize ?? !1,
      sizeDependencies: n.sizeDependencies ?? null,
      onResize: n.onResize
    };
  }
  return {
    watchData: !1,
    emitResize: !1,
    sizeDependencies: null,
    ...n
  };
}
function ot(n, i) {
  n.item !== i.item && (n.item = i.item), n.active !== i.active && (n.active = i.active), n.index !== i.index && (n.index = i.index), n.watchData !== i.watchData && (n.watchData = i.watchData), n.sizeDependencies !== i.sizeDependencies && (n.sizeDependencies = i.sizeDependencies), n.emitResize !== i.emitResize && (n.emitResize = i.emitResize), n.onResize !== i.onResize && (n.onResize = i.onResize);
}
function ct(n, i) {
  n.onResize !== i.onResize && (n.onResize = i.onResize);
}
function ut(n, i, l, a) {
  return l ? a ?? null : ke(n, a, i);
}
function vt(n) {
  const i = Ye(n);
  let l = 0, a = {};
  const d = et();
  let p = !1, w, x = !1, D = [], y = null, m = null, R = null;
  const g = /* @__PURE__ */ new Set(), I = [], v = pe({
    active: !0,
    sizes: {},
    keyField: o().keyField,
    simpleArray: !1
  }), C = W(() => {
    const e = j(o().items);
    return nt(e), e;
  }), E = W(() => o().direction ?? "vertical"), b = W(() => j(o().el)), Me = W(() => j(o().before)), Ae = W(() => j(o().after)), H = /* @__PURE__ */ new Map();
  function o() {
    return i.value;
  }
  const z = W(() => j(o().enabled ?? !0));
  function $(e) {
    let t = -1;
    return t = requestAnimationFrame(() => {
      g.delete(t), e();
    }), g.add(t), t;
  }
  function le() {
    for (const e of g)
      cancelAnimationFrame(e);
    g.clear();
  }
  const xe = tt({
    // Spread row measurement across frames so one huge flush cannot monopolize layout time.
    maxTasksPerFlush: 6,
    overflowQueueFlush(e) {
      $(e);
    }
  });
  typeof ResizeObserver < "u" && (w = new ResizeObserver((e) => {
    $(() => {
      if (Array.isArray(e)) {
        for (const t of e)
          if (t.target && t.target.$_vs_onResize) {
            let r, s;
            if (t.borderBoxSize) {
              const u = t.borderBoxSize[0];
              r = u.inlineSize, s = u.blockSize;
            } else
              r = t.contentRect.width, s = t.contentRect.height;
            t.target.$_vs_onResize(t.target.$_vs_id, r, s);
          }
      }
    });
  }));
  const Z = {
    vscrollData: v,
    resizeObserver: w,
    measureQueue: xe,
    direction: E,
    undefinedMap: a,
    undefinedSizeCount: {
      get value() {
        return l;
      },
      set value(e) {
        l = e;
      }
    },
    onVscrollUpdate(e) {
      const t = (r) => {
        e(r);
      };
      return d.on("vscroll:update", t), () => d.off("vscroll:update", t);
    }
  };
  G("vscrollData", v), G("vscrollParent", {
    get $_undefinedSizes() {
      return l;
    },
    set $_undefinedSizes(e) {
      l = e;
    },
    get $_undefinedMap() {
      return a;
    },
    set $_undefinedMap(e) {
      a = e;
    },
    $_events: d,
    direction: E
  }), G("vscrollResizeObserver", w), G("vscrollMeasurementContext", Z), G("vscrollAnchorRegistry", {
    delete(e) {
      H.delete(e);
    },
    set(e, t) {
      H.set(e, t);
    }
  });
  const k = W(() => {
    const e = C.value;
    return e.length > 0 && typeof e[0] != "object";
  }), oe = Y(0), L = Y(I);
  ge(() => {
    if (!z.value)
      return;
    const e = m || !b.value ? null : De(b.value.scrollTop, I), r = o().keyField, s = k.value, u = v.sizes, c = C.value, f = c.length;
    let S = I.length !== f, h = I.length !== f;
    for (let _ = 0; _ < f; _++) {
      const M = c[_], K = s ? _ : Xe(M, _, r);
      let B = u[K];
      typeof B > "u" && !a[K] && (B = 0);
      let P = I[_];
      if (!P) {
        P = ie({
          item: M,
          id: K,
          size: B
        }), I[_] = P, S = !0, h = !0;
        continue;
      }
      P.item !== M && (P.item = M, S = !0, h = !0), P.id !== K && (P.id = K, S = !0, h = !0), P.size !== B && (P.size = B, S = !0);
    }
    I.length !== f && (I.length = f, S = !0, h = !0), S && (y = e, oe.value++, h ? L.value = I.slice() : he(L));
  });
  function De(e, t) {
    if (!t.length)
      return null;
    const r = o().minItemSize;
    let s = 0, u = 0, c = t[0].id;
    for (const f of t) {
      const S = f.size || r, h = s + S;
      if (u = s, c = f.id, e < h)
        return {
          key: f.id,
          offset: e - s
        };
      s = h;
    }
    return {
      key: c,
      offset: Math.max(0, e - u)
    };
  }
  const J = o();
  D = X(C.value, k.value ? null : J.keyField), J.cache && (v.sizes = ye(J.cache, C.value, k.value ? null : J.keyField));
  function Oe() {
    var e, t;
    (t = (e = o()).onHidden) == null || t.call(e);
  }
  function Pe(e, t, r, s) {
    var u, c;
    (c = (u = o()).onUpdate) == null || c.call(u, e, t, r, s);
  }
  const Ce = pe({
    get enabled() {
      return z.value;
    },
    get items() {
      return L.value;
    },
    get keyField() {
      return "id";
    },
    get direction() {
      return E.value;
    },
    get itemSize() {
      return null;
    },
    get gridItems() {
    },
    get itemSecondarySize() {
    },
    get minItemSize() {
      return o().minItemSize;
    },
    get sizeField() {
      return "size";
    },
    get typeField() {
      return "type";
    },
    get buffer() {
      return o().buffer ?? 200;
    },
    get pageMode() {
      return o().pageMode ?? !1;
    },
    get shift() {
      return !1;
    },
    get cache() {
      return o().cache;
    },
    get prerender() {
      return o().prerender ?? 0;
    },
    get emitUpdate() {
      return o().emitUpdate ?? !1;
    },
    get disableTransform() {
      return o().disableTransform ?? !1;
    },
    get flowMode() {
      return o().flowMode ?? !1;
    },
    get hiddenPosition() {
      return o().hiddenPosition;
    },
    get updateInterval() {
      return o().updateInterval ?? 0;
    },
    get el() {
      return b.value;
    },
    get before() {
      return Me.value;
    },
    get after() {
      return Ae.value;
    },
    get scrollParent() {
      return o().scrollParent;
    },
    get onResize() {
      return ce;
    },
    get onVisible() {
      return ue;
    },
    get onHidden() {
      return Oe;
    },
    get onUpdate() {
      return Pe;
    }
  });
  function ce() {
    var e, t;
    N(), (t = (e = o()).onResize) == null || t.call(e);
  }
  function ue() {
    var e, t;
    d.emit("vscroll:update", { force: !1 }), (t = (e = o()).onVisible) == null || t.call(e);
  }
  const F = Je(
    Ce
  ), O = /* @__PURE__ */ new WeakMap(), ae = /* @__PURE__ */ new WeakMap(), ee = Y([]);
  function Ee(e) {
    const t = o();
    return Ie(Q(e, O), {
      direction: E.value,
      mode: se({
        direction: E.value,
        disableTransform: t.disableTransform ?? !1,
        flowMode: t.flowMode ?? !1
      })
    });
  }
  function fe(e) {
    let t = ae.get(e);
    return t || (t = it(e), ae.set(e, t), O.set(t, e)), t;
  }
  ge(() => {
    const e = F.pool.value, t = e.length, r = ee.value;
    let s = r.length !== t;
    for (let u = 0; u < t; u++) {
      const c = fe(e[u]);
      r[u] !== c && (r[u] = c, s = !0);
    }
    r.length !== t && (r.length = t, s = !0), s && he(ee);
  });
  const Ke = W(
    () => F.visiblePool.value.map(fe)
  ), V = /* @__PURE__ */ new WeakMap();
  function te() {
    R != null && (cancelAnimationFrame(R), g.delete(R), R = null);
  }
  function T() {
    te(), m = null;
  }
  function Be() {
    m == null || R != null || (R = $(() => {
      R = null, ne();
    }));
  }
  function We() {
    const e = b.value;
    if (!e)
      return null;
    const t = e.getBoundingClientRect();
    let r = null;
    for (const [s, u] of H.entries()) {
      if (!u.active || getComputedStyle(s).visibility === "hidden")
        continue;
      const c = s.getBoundingClientRect();
      if (c.bottom <= t.top || c.top >= t.bottom)
        continue;
      const f = Math.max(c.top, t.top) - t.top;
      (!r || f < r.score) && (r = {
        key: u.id,
        offset: c.top - t.top,
        score: f
      });
    }
    return r;
  }
  function Ue(e) {
    const t = b.value;
    if (!t) {
      T();
      return;
    }
    const r = t.scrollTop, s = Math.min(F.findItemIndex(r), e.length - 1), u = e[s];
    if (u == null) {
      T();
      return;
    }
    const c = We();
    m = {
      logicalKey: u,
      logicalOffset: r - F.getItemOffset(s),
      pendingKeys: /* @__PURE__ */ new Set(),
      stableFrames: 0,
      visualKey: (c == null ? void 0 : c.key) ?? null,
      visualOffset: (c == null ? void 0 : c.offset) ?? 0
    };
  }
  function de(e) {
    const t = b.value;
    return !t || Math.abs(t.scrollTop - e) < 0.5 ? !1 : (x = !0, t.scrollTop = e, F.updateVisibleItems(!0), t.dispatchEvent(new Event("scroll")), $(() => {
      x = !1;
    }), !0);
  }
  function ne() {
    const e = m, t = b.value;
    if (!e || !t)
      return;
    const r = L.value.findIndex((f) => f.id === e.logicalKey);
    if (r === -1) {
      T();
      return;
    }
    let s = !1;
    const u = F.getItemOffset(r) + e.logicalOffset;
    if (s = de(u) || s, !s && e.visualKey != null)
      for (const [f, S] of H.entries()) {
        if (!S.active || S.id !== e.visualKey || getComputedStyle(f).visibility === "hidden")
          continue;
        const h = f.getBoundingClientRect().top - t.getBoundingClientRect().top - e.visualOffset;
        s = de(t.scrollTop + h) || s;
        break;
      }
    let c = !0;
    for (const f of e.pendingKeys)
      if (!(typeof v.sizes[f] == "number" && v.sizes[f] > 0)) {
        c = !1;
        break;
      }
    if (!s && c) {
      if (e.stableFrames++, e.stableFrames >= 2) {
        T();
        return;
      }
    } else
      e.stableFrames = 0;
    Be();
  }
  function me(e, t, r, s) {
    const u = Ge(), c = Y(t), f = ie({
      ...r
    }), S = ie({
      onResize: r.onResize
    }), h = Y(e), _ = u.run(() => (A(() => we(
      c.value,
      f,
      o().keyField,
      v.simpleArray,
      v.active,
      O
    ), () => {
      const M = h.value;
      if (M) {
        const K = we(
          c.value,
          f,
          o().keyField,
          v.simpleArray,
          v.active,
          O
        ), B = K.id;
        B != null && H.set(M, {
          active: K.active,
          id: B
        });
      }
    }, {
      immediate: !0
    }), A(() => lt(
      c.value,
      E.value,
      o().flowMode ?? !1,
      O
    ), () => {
      const M = h.value;
      M && ze(
        M,
        c.value,
        E.value,
        o().disableTransform ?? !1,
        o().flowMode ?? !1,
        s,
        O
      );
    }, {
      immediate: !0
    }), Ze(
      f,
      h,
      Z,
      S
    )));
    _.mount(), V.set(e, {
      binding: c,
      scope: u,
      options: f,
      callbacks: S,
      el: h,
      controller: _,
      restoreStyles: s
    });
  }
  const $e = {
    mounted(e, t) {
      if (!z.value)
        return;
      const r = Se(e);
      me(e, t.value, Re(t.value, O), r);
    },
    updated(e, t) {
      if (!z.value)
        return;
      const r = V.get(e), s = Re(t.value, O);
      if (!r) {
        const c = Se(e);
        me(e, t.value, s, c);
        return;
      }
      const u = r.binding.value !== t.value;
      u && (r.binding.value = t.value), ot(r.options, s), ct(r.callbacks, s), r.el.value !== e && (r.el.value = e), u && ze(
        e,
        t.value,
        E.value,
        o().disableTransform ?? !1,
        o().flowMode ?? !1,
        r.restoreStyles,
        O
      );
    },
    unmounted(e) {
      const t = V.get(e);
      t && (t.controller.unmount(), t.scope.stop(), _e(e, t.restoreStyles), H.delete(e), V.delete(e));
    }
  };
  function N(e = !1) {
    z.value && ((e || k.value) && (v.sizes = {}), d.emit("vscroll:update", { force: !0 }));
  }
  function He(e, t) {
    F.scrollToItem(e, t);
  }
  function ve(e) {
    const t = o();
    return v.sizes = ye(e, C.value, k.value ? null : t.keyField), F.restoreCache(e);
  }
  function Le(e, t) {
    const r = o(), s = t ?? C.value.indexOf(e), u = k.value ? s : ke(e, s >= 0 ? s : t, r.keyField);
    return v.sizes[u] || 0;
  }
  function Ne() {
    if (!z.value)
      return;
    const e = b.value;
    e && (p || (p = !0, re(() => {
      e.scrollTop = e.scrollHeight + 5e3;
      const t = () => {
        e.scrollTop = e.scrollHeight + 5e3, $(() => {
          e.scrollTop = e.scrollHeight + 5e3, l === 0 ? p = !1 : $(t);
        });
      };
      $(t);
    })));
  }
  function q() {
    m && !x && T();
  }
  return A(() => C.value.slice(), (e, t) => {
    if (!z.value)
      return;
    const r = o(), s = k.value ? null : r.keyField, u = X(e, s);
    if (r.shift) {
      const c = t ? X(t, s) : D, f = Ve(c, u);
      f > 0 ? (Ue(c), m && (m.pendingKeys = new Set(u.slice(0, f)), m.stableFrames = 0, re(() => {
        m && ne();
      }))) : T();
    } else
      T();
    D = u, N();
  }, { flush: "sync" }), A(() => o().cache, (e) => {
    z.value && e && ve(e);
  }), A(() => o().keyField, (e) => {
    z.value && (v.keyField = e, D = X(C.value, k.value ? null : e), T(), N(!0));
  }, { flush: "sync" }), A(k, (e) => {
    v.simpleArray = e;
  }, { immediate: !0 }), A(() => o().direction, () => {
    z.value && (T(), N(!0));
  }), A(b, (e, t) => {
    t == null || t.removeEventListener("scroll", q), z.value && (e == null || e.addEventListener("scroll", q));
  }, {
    immediate: !0
  }), A(z, (e) => {
    const t = b.value;
    e ? (t == null || t.addEventListener("scroll", q), N()) : (t == null || t.removeEventListener("scroll", q), te(), le(), T());
  }), A(oe, () => {
    if (!z.value)
      return;
    const e = b.value;
    if (!e)
      return;
    if (m) {
      ne();
      return;
    }
    const t = y;
    if (y = null, !t)
      return;
    const r = L.value.findIndex((c) => c.id === t.key);
    if (r === -1)
      return;
    const s = F.getItemOffset(r) + t.offset;
    s - e.scrollTop !== 0 && (e.scrollTop = s);
  }, { flush: "post" }), Qe(() => {
    v.active = !0;
  }), qe(() => {
    v.active = !1;
  }), je(() => {
    var e;
    te(), le(), (e = b.value) == null || e.removeEventListener("scroll", q), d.clear();
  }), {
    vscrollData: v,
    itemsWithSize: L,
    resizeObserver: w,
    measurementContext: Z,
    vDynamicScrollerItem: $e,
    ...F,
    pool: ee,
    visiblePool: Ke,
    simpleArray: k,
    forceUpdate: N,
    scrollToItem: He,
    restoreCache: ve,
    getItemSize: Le,
    getViewStyle: Ee,
    scrollToBottom: Ne,
    onScrollerResize: ce,
    onScrollerVisible: ue
  };
}
export {
  vt as useDynamicScroller
};
//# sourceMappingURL=useDynamicScroller.js.map
